{
    "IncludeendedonholdLabel": "Le chiamate terminate in attesa vengono abbandonate",
    "UnreturnedCalls_SectionHeader": "Chiamate non risposte",
    "UnreturnedCalls_SectionPara": "È possibile scegliere se alcuni tipi di chiamate sono considerati abbandonati nei rapporti \"Chiamate perse non restituite\" e nella statistica \"Chiamate non restituite\".",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Le chiamate terminate per fuga sono abbandonate"
}